/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Template_Style_5aInputs */



/**
* | output |
* | --- |
* | "Style 5A" |
*
* @param {Ccsl_Export_Template_Style_5aInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_template_style_5a = /** @type {((inputs?: Ccsl_Export_Template_Style_5aInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Template_Style_5aInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Style 5A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stil 5A")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stile 5A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Стиль 5А")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estilo 5A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("款式 5A")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイル5A")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शैली 5ए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Estilo 5A")
	return /** @type {LocalizedString} */ ("Style 5A")
});